import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            最新动态
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            平台最新上线的影片和功能更新，不错过任何精彩
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200/70 hidden sm:block"></div>

          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-5">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                  <div className={`w-[10px] h-[10px] rounded-full border-2 ${
                    idx === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-primary-300'
                  }`}></div>
                </div>
                <div className="flex-1 bg-background-100 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`inline-block sm:ml-2 px-2 py-0.5 text-[11px] font-semibold rounded-full whitespace-nowrap ${
                      item.tag === '新上线' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '完结' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '专题' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '升级' ? 'bg-foreground-100 text-foreground-700' :
                      item.tag === '热播' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '功能' ? 'bg-primary-100 text-primary-700' :
                      'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}